import React from 'react';

import { GoalDetailHeader } from './components/goal-detail-header';
import { ProgressSection } from './components/progress-section';
import { SubItemsSection } from './components/sub-items-section';

export const Summary: React.FC = () => {
  return (
    <>
      <GoalDetailHeader />
      <ProgressSection />
      <SubItemsSection grow hasLink />
    </>
  );
};
